import validate from "/build/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.8_db0@0.3.2_ioredis@5.6.1_magicast@0_9242174a7ccfb2fb8925d700db8ff115/node_modules/nuxt/dist/pages/runtime/validate.js";
import login_45global from "/build/middleware/login.global.ts";
import manifest_45route_45rule from "/build/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.8_db0@0.3.2_ioredis@5.6.1_magicast@0_9242174a7ccfb2fb8925d700db8ff115/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  login_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}